import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { PASSWORD_RULES } from '../../validators/password';

interface PasswordRuleState {
  key: string;
  label: string;
  met: boolean;
}

/**
 * Live checklist of the password policy: each rule turns green as the typed password satisfies it.
 * Link the input to it with `aria-describedby` pointing at `listId`.
 */
@Component({
  selector: 'app-password-checklist',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p class="password-checklist__title">A senha precisa ter:</p>
    <ul class="password-checklist" [id]="listId()">
      @for (rule of rules(); track rule.key) {
        <li class="password-checklist__item" [class.is-met]="rule.met">
          <i class="fas password-checklist__icon" [class.fa-circle-check]="rule.met" [class.fa-circle]="!rule.met" aria-hidden="true"></i>
          <span>{{ rule.label }}</span>
          <span class="visually-hidden">{{ rule.met ? '(ok)' : '(falta)' }}</span>
        </li>
      }
    </ul>
  `,
})
export class PasswordChecklistComponent {
  readonly password = input<string | null | undefined>('');
  readonly listId = input<string>('password-rules');

  protected readonly rules = computed<PasswordRuleState[]>(() => {
    const value: string = this.password() ?? '';
    return PASSWORD_RULES.map((rule) => ({ key: rule.key, label: rule.label, met: rule.test(value) }));
  });
}
